export class ClientSearchModel implements IClientSearchModel {
  clientSummary?: string | undefined;
  clientTags?: string[] | undefined;
  clientStatus?: string | undefined;
  isActive?: boolean | undefined;
  expectedInternsFrom?: number | undefined;
  expectedInternsTo?: number | undefined;
  onboardingClientSettingId?: string | undefined;
  onboardingStepsComplete?: number | undefined;
  onboardingPercent?: number | undefined;
  companyType?: string | undefined;
  contractYearExpires?: number | undefined;
  sponsorshipFee?: number | undefined;

  constructor(data?: IClientSearchModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.clientSummary = Data["clientSummary"];
      if (Array.isArray(Data["clientTags"])) {
        this.clientTags = [] as any;
        for (let item of Data["clientTags"])
          this.clientTags!.push(item);
      }
      this.clientStatus = Data["clientStatus"];
      this.isActive = Data["isActive"];
      this.expectedInternsFrom = Data["expectedInternsFrom"];
      this.expectedInternsTo = Data["expectedInternsTo"];
      this.onboardingClientSettingId = Data["onboardingClientSettingId"];
      this.onboardingStepsComplete = Data["onboardingStepsComplete"];
      this.onboardingPercent = Data["onboardingPercent"];
      this.companyType = Data["companyType"];
      this.contractYearExpires = Data["contractYearExpires"];
      this.sponsorshipFee = Data["sponsorshipFee"];
    }
  }

  static fromJS(data: any): ClientSearchModel {
    data = typeof data === 'object' ? data : {};
    let result = new ClientSearchModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["clientSummary"] = this.clientSummary;
    if (Array.isArray(this.clientTags)) {
      data["clientTags"] = [];
      for (let item of this.clientTags)
        data["clientTags"].push(item);
    }
    data["clientStatus"] = this.clientStatus;
    data["isActive"] = this.isActive;
    data["expectedInternsFrom"] = this.expectedInternsFrom;
    data["expectedInternsTo"] = this.expectedInternsTo;
    data["onboardingClientSettingId"] = this.onboardingClientSettingId;
    data["onboardingStepsComplete"] = this.onboardingStepsComplete;
    data["onboardingPercent"] = this.onboardingPercent;
    data["companyType"] = this.companyType;
    data["contractYearExpires"] = this.contractYearExpires;
    data["sponsorshipFee"] = this.sponsorshipFee;
    return data;
  }
}

export interface IClientSearchModel {
  clientSummary?: string | undefined;
  clientTags?: string[] | undefined;
  clientStatus?: string | undefined;
  isActive?: boolean | undefined;
  expectedInternsFrom?: number | undefined;
  expectedInternsTo?: number | undefined;
  onboardingClientSettingId?: string | undefined;
  onboardingStepsComplete?: number | undefined;
  onboardingPercent?: number | undefined;
  companyType?: string | undefined;
  contractYearExpires?: number | undefined;
  sponsorshipFee?: number | undefined;
}